import { autoinject } from 'aurelia-framework';
import { I18N } from 'aurelia-i18n';

@autoinject
export class LocaleNameValueConverter {
  constructor(private i18N: I18N) {}

  toView(item: object) {
    if (!item) return '';
    return this.getLocaleName(this.i18N.getLocale(), item);
  }

  private getLocaleName(lang, item) {
    switch (lang) {
      case 'nb-NO':
        return item['Name'];
      case 'en':
        return item['Name' + 'En'] ? item['Name' + 'En'] : item['Name'];
      case 'es':
        return item['Name' + 'Es'] ? item['Name' + 'Es'] : item['Name' + 'En'];
      default:
        return item['Name'];
    }
  }
}
